"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useState = void 0;
var useState = function () {
    var state = {
        activeStep: 1,
        furthestVisitedStep: 1,
        queryInProgress: false,
        totalSteps: 7,
        activePaneElement: null,
        transitioningPanes: [],
        advisors: [],
        availableAdvisorPool: [],
        matchingAdvisors: [],
        advisorOffices: [],
        wizard: {
            location: [],
            income: [],
            assets: [],
            occupation: [],
            age: [],
            goals: [],
        },
        wizardStatus: 'show',
        zipCode: ''
    };
    var stateEvents = [];
    var singleStateEvents = [];
    var setState = function (update) {
        var keys = Object.keys(update);
        var stateClone = __assign({}, state);
        state = Object.assign(state, update);
        keys.forEach(function (key) {
            if (stateEvents[key]) {
                stateEvents[key].forEach(function (cb) { return cb(stateClone, update); });
            }
            if (singleStateEvents[key]) {
                singleStateEvents[key].forEach(function (cb) { return cb(stateClone, update); });
                delete singleStateEvents[key];
            }
        });
    };
    var subscribe = function (key, cb) {
        if (!stateEvents[key]) {
            stateEvents[key] = [];
        }
        stateEvents[key].push(cb);
    };
    var subscribeOnce = function (key, cb) {
        if (!singleStateEvents[key]) {
            singleStateEvents[key] = [];
        }
        singleStateEvents[key].push(cb);
    };
    return { state: state, setState: setState, subscribe: subscribe, subscribeOnce: subscribeOnce };
};
exports.useState = useState;
